import * as types from '@/store/types';
import {
    IDashboardStatsModel,
    ISiteManualDetailModel,
    ISiteManualListModel,
    IModelWithLoading
} from '@/entities';
import dashboardApi from '@/api/dashboard.api';
import siteManualsApi from '@/api/site-manuals.api';

interface State {
    dashboard: IModelWithLoading<IDashboardStatsModel>;
    siteManuals: IModelWithLoading<ISiteManualListModel[]>;
}
// default state
const initialState: State = {
    dashboard: { loading: false, model: null },
    siteManuals: { loading: false, model: null }
};

const START_LOADING = 'apidata/START_LOADING';
const LOADING_COMPLETE = 'apidata/LOADING_COMPLETE';
const LOADING_ERROR = 'apidata/LOADING_ERROR';

interface KeyPayload {
    key: 'dashboard' | 'siteManuals';
}

interface LoadingCompletePayload extends KeyPayload {
    data: any;
}

const mutations = {
    [START_LOADING]: (state: State, payload: KeyPayload) => {
        const key = payload.key;
        state[key].loading = true;
    },
    [LOADING_COMPLETE]: (state: State, payload: LoadingCompletePayload) => {
        const key = payload.key;
        state[key].model = payload.data;
        state[key].loading = false;
    },
    [LOADING_ERROR]: (state: State, payload: KeyPayload) => {
        const key = payload.key;
        state[key].loading = false;
    }
};

// actions

async function processEnter(
    commit,
    state,
    key: string,
    loadDataFunc: () => Promise<any>
) {
    const keyPaload = { key };
    if (state[key].model == null) {
        // show loading only if empty data
        commit(START_LOADING, keyPaload);
    }
    try {
        const data = await loadDataFunc();
        commit(LOADING_COMPLETE, { ...keyPaload, data });
    } finally {
        commit(LOADING_ERROR, { ...keyPaload });
    }
}

const actions = {
    [types.APIDATA_DASHBOARD_ENTER]: async ({ commit, state }) => {
        processEnter(commit, state, 'dashboard', () => {
            return dashboardApi.dashboard();
        });
    },
    [types.APIDATA_SITEMANUALS_ENTER]: async ({ commit, state }) => {
        processEnter(commit, state, 'siteManuals', () => {
            return siteManualsApi.list({
                sortField: 'sitename',
                sortAsc: true
            });
        });
    }
};

// getters
const getters = {
    [types.APIDATA_GET_DASHBOARD]: (state: State) => {
        return state.dashboard;
    },
    [types.APIDATA_GET_SITEMANUALS]: (state: State) => {
        return state.siteManuals;
    }
};

export default {
    state: initialState,
    mutations,
    actions,
    getters
};
